import React from 'react'
import update from 'immutability-helper';

import { user } from '../../../core/controllers/user';
import { financial } from '../../../core/controllers/Financial';
import { modal } from '../../../core/utilities/modal';

export default class LateRent extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            late_rent_fee: 0
        }
    }

    componentDidMount() {
        var self = this;
        financial.getLateRentFee(function(response) {
            var fee = (response.data).toLocaleString('en-US', {
                style: 'currency',
                currency: 'USD',
            });

            self.setState({
                late_rent_fee: fee
            });
        });
    }

    componentWillUpdate(nextProps, nextState) {

    }

    /**
     * Formats money, if not value, return 0
     * @param {*} e
     */
    formatAmount(value) {
        var money = parseInt(value);
        money = Number(money.toFixed(2)).toLocaleString();
        if(money == 'NaN') { money = 0; }

        return money;
    }

    /* color related handlers for onchange */
    handleLateRent(e) {
        var money = this.formatAmount(e.target.value);
        this.setState({
            late_rent_fee: money
        });
    }

    updateLateRentFee() {
        financial.updateLateRentFee(this.state, function(response) {
            modal.showInfo("Late Rent Fee was updated!", "success", "top", "center");
        });
    }

    render(){
        return (
            <div class="col-md-8">
                <div class="card">
                    <div class="header">
                        <h4 class="title"><i class="pe-7s-edit"></i> <small><i class="pe-7s-angle-right"></i></small> Late Rent</h4>
                        <p class="category">Fee(s)</p>
                    </div>
                    <div class="content">
                        <div class="row">
                            <div class="col-md-12">
                                <p class="category"><b></b></p>
                            </div>
                            <div id="colorSelects">
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label>Late Rent</label>
                                        <input type="text" class="form-control" name="laterent" placeholder="" id="laterent" value={this.state.late_rent_fee} onChange={this.handleLateRent.bind(this)}/>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <button type="button" id="save-color-coding" data-loading-text="Loading..." class="add-tenant btn btn-info btn-fill pull-right" autoComplete="off" onClick={this.updateLateRentFee.bind(this)}>
                                    Update
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
};


// WEBPACK FOOTER //
// app/components/Settings/Financial/LateRent.jsx